import React, { useState, useEffect, useRef } from 'react';
import './Header.css';
import image1 from '../images/Screenshot_20250217-134629.png'

import mdulogo from "../images/unnamed.png"
import { Link } from 'react-router-dom';
import Typed from 'typed.js';
import AOS from 'aos';
import 'aos/dist/aos.css'


const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false); 
  const typedElement = useRef(null); 


  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
   
    const typed = new Typed(typedElement.current, {
      strings: ['Pandit L. R. School of Pharmacy ','Pt. L. R. School of Pharmacy'],
      typeSpeed: 80, 
      backSpeed: 50,   
     backDelay: 50, 
       startDelay: 100, 
       loop:true,
      showCursor: false, 
      smartBackspace: true,
    });

   
    return () => {
      typed.destroy();
    };
  }, []);
 
  return (
    

    <div className="headersection1">
      <img className="image1" src={image1} alt="College Logo" />
     
    
      <div className="header-container">
        <div className="hamburger" onClick={toggleMenu}>
          <div className={`lbar ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`lbar ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`lbar ${isMenuOpen ? 'open' : ''}`}></div>
        </div>

        <div className="college-name">
          <h1 ref={typedElement} className='element'></h1> 
        </div>
       
        <ul className={`menu-list ${isMenuOpen ? 'show' : ''}`}>
        
        {/* <li className="list">
        <Link to="/EnquiryForm" className="anchor">Admission2025</Link>    
        </li> */}
<li className="list">
 <Link to="/course" className="anchor">Course</Link> 
</li>
<li className="list">
{/* <Link to="/All" className="anchor">Login</Link> */}
</li>
{/* <li className="list">
<Link to="/EnquiryForm" className="anchor">Enquiry</Link>
</li> */}
 </ul>
 </div>
</div>
   
  );
};

export default Header;
